import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GrowerBenchmarkRetailMonthValuesFieldsFragment = { __typename?: 'GrowerBenchmarkRetailMonthValues', grossSales: number, customerCount: number, grossMarginDollars: number, laborDollars: number, laborHours: number, unitCount?: number | null };

export type GrowerBenchmarkRetailMonthFieldsFragment = { __typename?: 'GrowerBenchmarkRetailMonth', communityId: string, reportingUnitId: string, periodId: string, status?: Types.GrowerBenchmarkSubmissionStatus | null, version?: number | null, submissionId?: string | null, values?: { __typename?: 'GrowerBenchmarkRetailMonthValues', grossSales: number, customerCount: number, grossMarginDollars: number, laborDollars: number, laborHours: number, unitCount?: number | null } | null };

export type GetGrowerBenchmarkRetailMonthsQueryVariables = Types.Exact<{
  reportingUnitId: Types.Scalars['String']['input'];
  fromPeriodId: Types.Scalars['String']['input'];
  toPeriodId: Types.Scalars['String']['input'];
}>;


export type GetGrowerBenchmarkRetailMonthsQuery = { __typename?: 'Query', growerBenchmarkRetailMonths: Array<{ __typename?: 'GrowerBenchmarkRetailMonth', communityId: string, reportingUnitId: string, periodId: string, status?: Types.GrowerBenchmarkSubmissionStatus | null, version?: number | null, submissionId?: string | null, values?: { __typename?: 'GrowerBenchmarkRetailMonthValues', grossSales: number, customerCount: number, grossMarginDollars: number, laborDollars: number, laborHours: number, unitCount?: number | null } | null }> };

export const GrowerBenchmarkRetailMonthValuesFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkRetailMonthValuesFields on GrowerBenchmarkRetailMonthValues {
  grossSales
  customerCount
  grossMarginDollars
  laborDollars
  laborHours
  unitCount
}
    `, {"fragmentName":"GrowerBenchmarkRetailMonthValuesFields"});
export const GrowerBenchmarkRetailMonthFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkRetailMonthFields on GrowerBenchmarkRetailMonth {
  communityId
  reportingUnitId
  periodId
  status
  version
  submissionId
  values {
    ...GrowerBenchmarkRetailMonthValuesFields
  }
}
    fragment GrowerBenchmarkRetailMonthValuesFields on GrowerBenchmarkRetailMonthValues {
  grossSales
  customerCount
  grossMarginDollars
  laborDollars
  laborHours
  unitCount
}`, {"fragmentName":"GrowerBenchmarkRetailMonthFields"});
export const GetGrowerBenchmarkRetailMonthsDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkRetailMonths($reportingUnitId: String!, $fromPeriodId: String!, $toPeriodId: String!) {
  growerBenchmarkRetailMonths(
    reportingUnitId: $reportingUnitId
    fromPeriodId: $fromPeriodId
    toPeriodId: $toPeriodId
  ) {
    ...GrowerBenchmarkRetailMonthFields
  }
}
    fragment GrowerBenchmarkRetailMonthValuesFields on GrowerBenchmarkRetailMonthValues {
  grossSales
  customerCount
  grossMarginDollars
  laborDollars
  laborHours
  unitCount
}
fragment GrowerBenchmarkRetailMonthFields on GrowerBenchmarkRetailMonth {
  communityId
  reportingUnitId
  periodId
  status
  version
  submissionId
  values {
    ...GrowerBenchmarkRetailMonthValuesFields
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetGrowerBenchmarkRetailMonths: build.query<GetGrowerBenchmarkRetailMonthsQuery, GetGrowerBenchmarkRetailMonthsQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkRetailMonthsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetGrowerBenchmarkRetailMonthsQuery, useLazyGetGrowerBenchmarkRetailMonthsQuery } = injectedRtkApi;
